module.exports = __webpack_public_path__ + "static/lander-32047f0999f268bab87b2be1703db781.png";